import { useAsyncData, useNuxtData } from '#app'
import { computed } from 'vue'

import type { HttpError } from '@backmarket/http-api/src/utils/HttpApiError'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useBouyguesPhonelineSetup() {
  const { user } = useUserStore()
  const $httpFetch = useHttpFetch()

  const { data, refresh, status, error } = useAsyncData(
    `phoneline-setup-${user.value?.bmUserId}`,
    async () => {
      try {
        const configuration = await $httpFetch(
          '/mobile-plan/api/v1/customer-account/phone-line-setup',
        )

        return configuration
      } catch (e) {
        const err = e as HttpError

        if (err.statusCode === 404) {
          // Allow cacheing empty responses
          return 'empty-response'
        }

        throw err
      }
    },
    {
      getCachedData: (key, nuxtApp, ctx) => {
        // Skip cache on manual refresh
        if (ctx.cause === 'refresh:manual') return undefined

        return useNuxtData(key).data.value || undefined
      },
      server: false,
    },
  )

  const isEmpty = computed(() => !data.value || data.value === 'empty-response')
  const phonelineSetup = computed(() =>
    typeof data.value === 'string' ? null : data.value,
  )

  return {
    phonelineSetup,
    refresh,
    status,
    isEmpty,
    error,
  }
}
